import { Tabs } from 'antd'
import type { TabsProps } from 'antd/lib'

import styles from './styles.module.scss'

export const StretchedTabs = (props: TabsProps) => {
  return <Tabs className={styles.stretchedTabs} {...props} />
}
